import {
  ALL_SERVICE_ITEMS,
  SERVICE_CATEGORIES,
  SERVICE_CATEGORIES_BY_KEY,
  SERVICE_ITEMS_BY_KEY,
} from "../data";
import type {
  Key,
  ServiceCategory,
  ServiceCategoryKey,
  ServiceItem,
  ServiceItemKey,
} from "../types";

/*
 * Service Categories
 */
export function getServiceCategory(key: ServiceCategoryKey): ServiceCategory {
  return SERVICE_CATEGORIES_BY_KEY[key];
}

type GetServiceCategoriesOptions = {
  limit?: number;
};

export function getServiceCategories(
  keys?: ServiceCategoryKey | ServiceCategoryKey[],
  options?: GetServiceCategoriesOptions,
): ServiceCategory[] {
  if (!keys) {
    return SERVICE_CATEGORIES;
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list
    .map(k => SERVICE_CATEGORIES_BY_KEY[k])
    .filter(Boolean)
    .slice(0, options?.limit);
}

/*
 * Service Items
 */
export function getServiceItem(key: ServiceItemKey): ServiceItem {
  return SERVICE_ITEMS_BY_KEY[key];
}

type GetServiceItemsOptions = {
  limit?: number;
};

export function getServiceItems(
  keys?: ServiceItemKey | ServiceItemKey[],
  options?: GetServiceItemsOptions,
): ServiceItem[] {
  if (!keys) {
    return ALL_SERVICE_ITEMS.slice(0, options?.limit);
  }

  const list = Array.from(new Set(Array.isArray(keys) ? keys : [keys]));

  return list
    .map(key => SERVICE_ITEMS_BY_KEY[key])
    .filter(Boolean)
    .slice(0, options?.limit);
}

type GetServiceItemOrCategoriesOptions = {
  limit?: number;
};

export function getServiceItemOrCategories(
  keys?: Key | Key[],
  options?: GetServiceItemOrCategoriesOptions,
) {
  if (!keys) {
    return [...ALL_SERVICE_ITEMS, ...SERVICE_CATEGORIES].slice(
      0,
      options?.limit,
    );
  }

  const list = Array.from(new Set(Array.isArray(keys) ? keys : [keys]));

  return list
    .map(key => SERVICE_ITEMS_BY_KEY[key] || SERVICE_CATEGORIES_BY_KEY[key])
    .filter(Boolean)
    .slice(0, options?.limit);
}
